import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
    Grid,
    Box,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    IconButton,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions
} from '@mui/material';
import { useTheme } from '@mui/system';
import { Delete, Edit, Add } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { gridSpacing } from 'utils/constants';
import MainCard from 'components/Cards/MainCard';
import ApiHelper from 'utils/apiHelper';
import AddEnergyRateDialog from './AddEnergyRateDialog';

const EnergyRates = () => {
    const theme = useTheme();
    const [energyRatesData, setEnergyRatesData] = useState([]);
    const [showAddDialog, setShowAddDialog] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);

    const [editRow, setEditRow] = useState(null);

    const { userInfo } = useSelector((state) => state.auth);

    useEffect(() => {
        getEnergyRateData();
    }, []);

    const getEnergyRateData = () => {
        ApiHelper.get('/api/management/energy_rates/')
            .then((res) => {
                setEnergyRatesData(res.data);
            })
            .catch((err) => {
                toast.error('Failed to get the users data');
                console.log(err);
            });
    };

    const handleEditUserDialog = (data) => {
        setEditRow(data);
        setShowAddDialog(true);
    };

    const handleDeleteClick = (id) => {
        setDeleteItemId(id);
        setDeleteDialogOpen(true);
    };

    const handleDeleteConfirm = () => {
        if (deleteItemId) {
            ApiHelper.delete(`/api/management/energy_rates/${deleteItemId}/`)
                .then((res) => {
                    if (res.data.status === 'success') {
                        toast.success('Successfully deleted data');
                        getEnergyRateData();
                    } else {
                        toast.error('Failed to delete data');
                    }
                })
                .catch((err) => {
                    toast.error('Failed to delete data');
                    console.log(err);
                });
        }
        setDeleteDialogOpen(false);
        setDeleteItemId(null);
    };

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
        setDeleteItemId(null);
    };

    const handleCloseAddDialog = () => {
        setShowAddDialog(false);
        setEditRow(null);
        getEnergyRateData();
    };
    return (
        <MainCard title="Energy Rates" cardHeaderShow={false}>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                    <Grid
                        container
                        item
                        sx={{
                            background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.primary[200]})`,
                            padding: 1
                        }}
                    >
                        <Grid item sm={9} md={9}>
                            {/*<Typography sx={{ color: '#FFFFFF', fontSize: '16px', marginTop: 1 }}>*/}
                            {/*    {userInfo.orgid !== null && userInfo.orgid.name}*/}
                            {/*</Typography>*/}
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                sx={{ float: 'right', backgroundColor: '#FFFFFF', borderRadius: '6px' }}
                                onClick={() => setShowAddDialog(true)}
                                startIcon={<Add />}
                                disabled={userInfo.admin_permissions.root_admin !== true}
                            >
                                Add Rate
                            </Button>
                        </Grid>
                    </Grid>
                    <Table sx={{ minWidth: 700 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ textAlign: 'center' }}>Name</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>Date</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>Default</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>Start Hour</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>End Hour</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>Energy Cost(/kWh)</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>
                                    CO<sub>2</sub> Cost(/kWh)
                                </TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>Green Percent(/kWh)</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>Options</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {energyRatesData.map((data, key) => (
                                <TableRow key={key} sx={{ borderBottom: key != energyRatesData.length - 1 ? '2px solid #000000' : '' }}>
                                    <TableCell sx={{ textAlign: 'center' }}>{data.name}</TableCell>
                                    <TableCell sx={{ textAlign: 'center' }}>
                                        <Typography>
                                            {(() => {
                                                const date = new Date(data.date);
                                                return `${date.getUTCMonth() + 1}-${date.getUTCDate()}-${date.getUTCFullYear()}`;
                                            })()}
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{ textAlign: 'center' }}>
                                        <Typography>{data.default ? 'Yes' : 'No'}</Typography>
                                    </TableCell>
                                    <TableCell colSpan={5}>
                                        <Table>
                                            <TableBody>
                                                {data.energy_data.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell sx={{ width: '12%', textAlign: 'center' }}>
                                                            <Typography>{row.start}</Typography>
                                                        </TableCell>
                                                        <TableCell sx={{ width: '13%', textAlign: 'center' }}>
                                                            <Typography>{row.end}</Typography>
                                                        </TableCell>
                                                        <TableCell sx={{ width: '20%', textAlign: 'center' }}>
                                                            <Typography>{row.energy_cost}</Typography>
                                                        </TableCell>
                                                        <TableCell sx={{ width: '20%', textAlign: 'center' }}>
                                                            <Typography>{row.co2_cost}</Typography>
                                                        </TableCell>
                                                        <TableCell sx={{ width: '20%', textAlign: 'center' }}>
                                                            <Typography>{row.green_percent}</Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableCell>

                                    <TableCell sx={{ textAlign: 'center' }}>
                                        <Box>
                                            <IconButton size="small" onClick={() => handleEditUserDialog(data)}>
                                                <Edit fontSize="small" />
                                            </IconButton>
                                            <IconButton size="small" onClick={() => handleDeleteClick(data.id)}>
                                                <Delete fontSize="small" />
                                            </IconButton>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Grid>
            </Grid>
            {showAddDialog && <AddEnergyRateDialog onClose={handleCloseAddDialog} editData={editRow} />}

            {/* Delete Confirmation Dialog */}
            <Dialog
                open={deleteDialogOpen}
                onClose={handleDeleteCancel}
                aria-labelledby="delete-dialog-title"
                aria-describedby="delete-dialog-description"
            >
                <DialogTitle id="delete-dialog-title">Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-dialog-description">
                        Are you sure you want to delete this energy rate? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteCancel}>Cancel</Button>
                    <Button onClick={handleDeleteConfirm} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </MainCard>
    );
};

export default EnergyRates;
